<template>
  <div>
    <div class="w100" v-if="siftData.length > 0">
      <SiftComp ref="sift" :sift-data="siftData" :loading="loading" @click-search="fetchData" />
    </div>

    <div class="w100 pb20 cl-f">
      <div class="fr pr10">
        <el-button v-if="appData" @click="$emit('click-collect', appData.isCollect)" :loading="collecting">
          <i class="yellow" :class="appData.isCollect ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
          {{ appData.isCollect ? '取消收藏' : '点击收藏' }}
        </el-button>
        <el-button v-if="siftData.length > 0" type="warning" :loading="loading" @click="download">导出</el-button>
        <el-button v-if="siftData.length > 0" type="primary" :loading="loading" @click="searchData">查询</el-button>
        <a class="none" id="downloadExcel" download="excel.xls"></a>
      </div>
    </div>

    <el-tabs v-model="activeName" v-loading="loading" type="border-card" @tab-click="fetchData">
      <el-tab-pane lazy label="我的待付款" name="WDDFK">
        <el-table class="w100 tx-c my-table" :data="list0.list" stripe border height="460" @row-click="clickRow">
          <el-table-column v-for="(item, index) in labelData" :key="index" :label="item.label" v-show="item.key != 'id'" resizable align="center">
            <template slot-scope="scope">
              <span>{{ scope.row[item.key] }}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="w100 mt20 tx-r">
          <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="list0.page" :page-sizes="[30, 50, 100]" :page-size="list0.size" layout="total, sizes, prev, pager, next, jumper" background :total="list0.total"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane lazy label="我的已付款" name="WDYFK">
        <el-table class="w100 tx-c my-table" :data="list1.list" stripe border height="460" @row-click="clickRow">
          <el-table-column v-for="(item, index) in labelData" :key="index" :label="item.label" v-show="item.key != 'id'" resizable align="center">
            <template slot-scope="scope">
              <span>{{ scope.row[item.key] }}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="w100 mt20 tx-r">
          <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="list1.page" :page-sizes="[30, 50, 100]" :page-size="list1.size" layout="total, sizes, prev, pager, next, jumper" background :total="list1.total"></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SiftComp from "@/components/CompSift/SiftComp";

export default {
  name: "StudentTuition",
  components: {
    SiftComp
  },
  props: ["url", "app-data", "collecting"],
  data() {
    return {

      loading: false,
      error: "",

      siftData: [],
      labelData: [],

      activeName: "WDDFK",
      list0: {
        total: 0,
        page: 1,
        size: 30,
        list: []
      },
      list1: {
        total: 0,
        page: 1,
        size: 30,
        list: []
      }
    };
  },
  computed: {
    ...mapState(["userData", "userToken"])
  },
  created() {},
  mounted() {
    this.fetchSiftData();
  },
  methods: {
    searchData() {
      this.list0.list = [];
      this.list0.total = 0;
      this.list0.page = 1;

      this.list1.list = [];
      this.list1.total = 0;
      this.list1.page = 1;

      this.$nextTick(() => {
        this.fetchData();
      });
    },
    fetchSiftData() {
      this.loading = true;

      this.$http
        .post(
          this.$route.query.interfaceUrl + `/getTitleData`,
          this.$qs.stringify({
            userId: this.userData.userId,
            id: this.$route.query.id
          })
        )
        .then(({ data }) => {
          if (data.resCode == 0 && data.resStatus == 0) {
            // console.log(data.resData);
            if (data.resData.siftData) {
              this.siftData = data.resData.siftData;
            }
            if (data.resData.labelData) {
              this.labelData = data.resData.labelData;
            }
            this.$nextTick(() => {
              this.fetchData();
            });
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.error = 404;
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });

          this.loading = false;
        });
    },
    fetchData() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }

      obj.userId = this.userData.userId;

      let url = "";
      if (this.activeName == "WDDFK") {
        url = "studentTuition/queryUnPayData";
        obj.pageNum = this.list0.page;
        obj.pageSize = this.list0.size;
      } else {
        url = "studentTuition/queryPayData";
        obj.pageNum = this.list1.page;
        obj.pageSize = this.list1.size;
      }
      // console.log(obj, url);

      this.loading = true;
      this.$http
        .post(url, this.$qs.stringify(obj))
        .then(({ data }) => {
          if (data.resCode == 0 && data.resStatus == 0) {
            // console.log(data);
            if (this.activeName == "WDDFK") {
              this.list0.total = data.resData.total;
              this.list0.list = data.resData.list;
            } else {
              this.list1.total = data.resData.total;
              this.list1.list = data.resData.list;
            }
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });
          // this.error = 404;
          this.loading = false;
        });
    },
    download() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }
      if (this.activeName == "WDDFK") {
        obj.type = "undo";
      } else {
        obj.type = "do";
      }
      obj.token = this.userToken;

      this.$http
        .get(this.$route.query.interfaceUrl + "/exportData", {
          params: obj,
          responseType: "blob"
        })
        .then(({ data }) => {
          // console.log(data);
          if (!data) {
            return;
          }
          document.getElementById(
            "downloadExcel"
          ).href = window.URL.createObjectURL(data);
          document.getElementById("downloadExcel").click();
          return;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });
        });
    },
    clickRow(row, event, column) {
      // console.log(row);
    },
    changeSize(value) {
      if (this.activeName == "WDDFK") {
        this.list0.size = value;
      } else {
        this.list1.size = value;
      }
      this.fetchData();
    },
    changePage(value) {
      if (this.activeName == "WDDFK") {
        this.list0.page = value;
      } else {
        this.list1.page = value;
      }
      this.fetchData();
    }
  }
};
</script>

<style scoped>
</style>
